import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DsChipColorVariant } from '@levelaccess/design-system';

import { IModal } from '@client/app/components/modals/modal.interface';
import { ModalContainerComponent } from '@client/app/components/modals/modal-container.component';
import { $comment, $manualAuditIssueComment } from '@shared/constants/comment';
import { RuleAuditHistoryService } from '@client/app/services/rule-audit-history.service';
import { IManualEvaluationAuditListItem } from '@shared/interfaces/manual-audit.interface';

@Component({
  selector: 'app-delete-comment',
  templateUrl: './delete-comment.component.html',
  styleUrls: ['./delete-comment.component.scss'],
  standalone: false,
})
export class DeleteCommentComponent implements IModal {
  @ViewChild(ModalContainerComponent, { static: true })
  public container: ModalContainerComponent;
  @Input()
  public comment: IManualEvaluationAuditListItem;
  @Output() public deleteCommentConfirmed: EventEmitter<string> = new EventEmitter<string>();
  public $comment: typeof $comment;
  public $manualAuditIssueComment: typeof $manualAuditIssueComment;
  protected readonly DsChipColorVariant: typeof DsChipColorVariant = DsChipColorVariant;

  constructor(private ruleAuditHistoryService: RuleAuditHistoryService) {
    this.$comment = $comment;
    this.$manualAuditIssueComment = $manualAuditIssueComment;
  }

  public get userAndTimestamp(): string {
    return this.ruleAuditHistoryService.getStatusLine(this.comment[$comment.createdAt], this.comment[$comment.user]);
  }

  public close(): void {
    this.container.closeModal();
  }

  public onCommentDelete(): void {
    this.deleteCommentConfirmed.emit(String(this.comment[$comment._id]));
    this.close();
  }
}
